module.exports = __webpack_public_path__ + "static/img/logo.e6b9efa2.png";